function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/*jshint esversion: 8 */
import { ComponentBase } from "./Shared/ComponentBase";
import { I18N } from "./Shared/I18n";
import { EventsApiService } from "./Services/EventsApiService";
import { DropdownBuilder } from "./Helpers/DropdownBuilder";
import { CardBuilder } from "./Helpers/CardBuilder";
import { QueryStringFilter } from "./Shared/QueryStringFilter";
import { AttributeFilter } from "./Shared/AttributeFilter";
import { ReturnContext } from "./Shared/ReturnContextProvider";
import { ErrorBuilder } from "./Helpers/ErrorBuilder";

var MppEventFinder = /*#__PURE__*/function (_ComponentBase) {
  _inherits(MppEventFinder, _ComponentBase);

  var _super = _createSuper(MppEventFinder);

  function MppEventFinder() {
    _classCallCheck(this, MppEventFinder);

    return _super.call(this);
  }

  _createClass(MppEventFinder, [{
    key: "attributeChangedCallback",
    value: function attributeChangedCallback(name, oldValue, newValue) {
      //console.log("Attribute changed!", `${name} changed from ${oldValue} to ${newValue}`);
      if (!!this._$searchButton) {
        if (this.loadAttributes()) {
          this._$searchButton.click();
        }
      }
    }
  }, {
    key: "loadAttributes",
    value: function loadAttributes() {
      this.targetUrl = this.getAttribute("targeturl") || this.getAttribute("target");
      this.maxNumberPerSeries = this.getAttribute("reduceseriesto") || "0";
      this.ministryIdAttribute = this.getAttribute("ministryid") || "0";
      this.signupIdAttribute = this.getAttribute("signuptype") || "0";
      this.monthIdAttribute = this.getAttribute("monthid") || "0";
      this.eventTypeIdAttribute = this.getAttribute("eventtypeid");
      var attributesChanged = false;

      if (!!this._$searchForm) {
        attributesChanged = AttributeFilter.ApplyFilter(this, this._$searchForm);
      }

      return attributesChanged;
    }
  }, {
    key: "connectedCallback",
    value: function () {
      var _connectedCallback = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _this = this;

        var i18n, eventsService;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return new I18N("mpp-event-finder")["catch"](function (error) {
                  if (error.toString().startsWith("TypeError")) {
                    _this._root.innerHTML = "Unable to connect.  Please check Permitted URLs.";
                  } else {
                    _this._root.innerHTML = "".concat(error);
                  }
                });

              case 2:
                i18n = _context.sent;
                this._i18n = i18n; //Load initial values of tag attributes:

                this.loadAttributes();

                if (!this.eventTypeIdAttribute) {
                  this._currentUrl = new URL(window.location.href);
                  this.eventTypeIdAttribute = this._currentUrl.searchParams.get("eventtypeid") || "0";
                }

                this._root.innerHTML =  `<link href="${this._appRoot}/Content/mppw-widgetstyles.css" rel="stylesheet" type="text/css"/><div class="mppw-component-container"><div class="mppw-form-wrapper"><h1>${ i18n.pageTitle }</h1><form class="mppw-form mppw-form-validate" id="searchForm"><input type="hidden" id="event" name="eventId" class="search-option"/> <input type="hidden" id="program" name="programId" class="search-option"/><div class="mppw-form-field mppw-form-field__static-container"><select name="congregationId" class="mppw-form-field__control search-option" id="congregationId" value=""></select> <label class="mppw-form-field__label" for="congregationId">${ i18n.congregationLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><input name="keyword" class="mppw-form-field__control search-option" type="text" id="keywordSearchText"/> <label class="mppw-form-field__label" for="keywordSearchText">${ i18n.keyWordLabel }</label></div><div class="mppw-right"><a class="mppw-btn secondary mppw-btn--small" href="#" id="advancedSearchLink" data-searchmode="0">${ i18n.showAdvancedSearchLabel }</a></div><div id="advancedSearchSection" style="display: none"><div class="mppw-form-field mppw-form-field__static-container"><select name="monthId" class="mppw-form-field__control search-option advanced-option" id="monthId" value=""></select> <label class="mppw-form-field__label" for="monthId">${ i18n.monthLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><select name="ministryId" class="mppw-form-field__control search-option advanced-option" id="ministryId" value=""></select> <label class="mppw-form-field__label" for="ministryId">${ i18n.ministryLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><select name="signUpType" class="mppw-form-field__control search-option advanced-option" id="signUpTypeId" value="0"><option value="0">${ i18n.allEventsLabel }</option><option value="1">${ i18n.registrationLabel }</option><option value="2">${ i18n.volunteerOpportunitiesLabel }</option></select> <label class="mppw-form-field__label" for="signUpTypeId">${ i18n.signupTypeLabel }</label></div><div class="mppw-form-field mppw-form-field__static-container"><div class="mppw-form-field__control" value=""><label><input name="isFeatured" value="true" type="checkbox" id="isFeatured" class="search-option advanced-option"/> <span class="mppw-checkbox"></span>${ i18n.featuredLabel }</label></div><label class="mppw-form-field__label">${ i18n.featuredLabel }</label></div></div><div class="mppw-centered"><input type="submit" class="mppw-btn primary" id="searchButton" value="${ i18n.searchButtonText }"/></div></form></div><div id="emptyContainer"><i class="mppw-spinner"></i></div><div class="resultsContainer mppw-card--grid" id="resultsContainer"></div><div id="viewMoreContainer"></div></div>` ;
                this._$searchForm = this._root.querySelector("#searchForm");
                this._$congregationId = this._root.querySelector("#congregationId");
                this._$ministryId = this._root.querySelector("#ministryId");
                this._$signUpTypeId = this._root.querySelector("#signUpTypeId");
                this._$monthId = this._root.querySelector("#monthId"); //this._$keywordSearchText = this._root.querySelector("#keywordSearchText");
                //this._$featured = this._root.querySelector("#featured");

                this._$searchButton = this._root.querySelector("#searchButton");
                this._$emptyContainer = this._root.querySelector("#emptyContainer");
                this._$resultsContainer = this._root.querySelector("#resultsContainer");
                this._$advancedSearchLink = this._root.querySelector("#advancedSearchLink");
                this._$advancedSearchSection = this._root.querySelector("#advancedSearchSection");
                this._$viewMoreContainer = this._root.querySelector("#viewMoreContainer");
                eventsService = new EventsApiService();
                eventsService.GetConfigurations().then(function (data) {
                  DropdownBuilder.LoadDropdown(_this._$congregationId, data.congregations, i18n.congregationPlaceholderText);
                  DropdownBuilder.LoadDropdown(_this._$ministryId, data.ministries, i18n.ministryPlaceHolderText);
                  DropdownBuilder.BuildMonthsList(_this._$monthId, i18n.monthPlaceHolderText);
                  DropdownBuilder.ReduceMonthDropDown(_this._$monthId, 4);
                  var advancedSearchOpened = false;
                  var returnContext = ReturnContext.Get(ReturnContext.Categories.Events);

                  if (!!returnContext && returnContext.Url == window.location.href) {
                    advancedSearchOpened = ReturnContext.ApplyFilter(returnContext.FormData, _this._$searchForm, _this._$advancedSearchSection);
                  } else {
                    advancedSearchOpened = QueryStringFilter.ApplyFilter(_this._$searchForm, _this._$advancedSearchSection);
                  }

                  AttributeFilter.ApplyFilter(_this, _this._$searchForm, true); //This could be improved since it duplicates code from below:

                  if (!!advancedSearchOpened) {
                    _this._$advancedSearchLink.innerHTML = i18n.hideAdvancedSearchLabel;
                    _this._$advancedSearchSection.style.display = "block";

                    _this._$advancedSearchLink.setAttribute("data-searchmode", "1");
                  }

                  _this._$searchButton.click();
                })["catch"](function (error) {
                  //TODO: Write error to UI
                  console.error(error);
                });

                this._$searchForm.addEventListener("submit", function (event) {
                  event.preventDefault();
                  var formData = new FormData(_this._$searchForm);
                  formData.append("MaxNumberPerSeries", _this.maxNumberPerSeries);
                  formData.append("EventTypeId", _this.eventTypeIdAttribute);
                  _this._$emptyContainer.innerHTML = "<i class=\"mppw-spinner\"></i>";
                  var resultsContainerHTML = "";
                  _this._$resultsContainer.innerHTML = resultsContainerHTML;
                  ReturnContext.Set(ReturnContext.Categories.Events, formData);
                  eventsService.GetEvents(formData).then(function (data) {
                    _this._$emptyContainer.innerHTML = "";
                    _this._$viewMoreContainer.innerHTML = "";

                    if (data.length === 0) {
                      _this._$emptyContainer.innerHTML += "<div id=\"eventsEmpty\" class=\"mppw-alert mppw-alert__warning\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(i18n.noEventsFoundMessage, "</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>");
                    } else {
                      for (var i = 0; i < data.length; i++) {
                        var _data$i = _objectSpread({}, data[i]),
                            featured = _data$i.featured,
                            imageUrl = _data$i.imageUrl,
                            title = _data$i.title,
                            description = _data$i.description,
                            id = _data$i.id,
                            location = _data$i.location,
                            startDate = _data$i.startDate,
                            endDate = _data$i.endDate;

                        var subtitlesArr = CardBuilder.BuildEventSubtitlesArr(location, startDate, endDate);
                        var targetUrl = CardBuilder.BuildUrl(_this.targetUrl, id);
                        resultsContainerHTML += CardBuilder.BuildCard(CardBuilder.BuildBadge(featured, 'featured') + CardBuilder.BuildImage(imageUrl, 'event'), CardBuilder.BuildText(title, subtitlesArr, description), CardBuilder.BuildDetailsButton(id, targetUrl, i18n.seeDetailsButtonText), targetUrl);
                      }

                      _this._$resultsContainer.innerHTML = resultsContainerHTML;

                      if (data.length > 20) {
                        _this._$viewMoreContainer.innerHTML += "<div class=\"mppw-alert mppw-alert__info\">\n\t\t\t\t\t\t\t\t<div class=\"mppw-alert__icon\"></div>\n\t\t\t\t\t\t\t\t<span class=\"mppw-alert__text\">".concat(i18n.viewMoreLabel, "</span>\n\t\t\t\t\t\t\t</div>");
                      }
                    }
                  })["catch"](ErrorBuilder.RenderHandler(_this._$emptyContainer));
                });

                this._$advancedSearchLink.addEventListener("click", function (event) {
                  var searchMode = _this._$advancedSearchLink.getAttribute("data-searchmode");

                  if (searchMode === "0") {
                    _this._$advancedSearchLink.innerHTML = _this._i18n.hideAdvancedSearchLabel;
                    _this._$advancedSearchSection.style.display = "block";

                    _this._$advancedSearchLink.setAttribute("data-searchmode", "1");
                  } else {
                    _this._$advancedSearchLink.innerHTML = _this._i18n.showAdvancedSearchLabel;
                    _this._$advancedSearchSection.style.display = "none";

                    _this._$advancedSearchLink.setAttribute("data-searchmode", "0");
                  }

                  _this._$ministryId.selectedIndex = _this.ministryIdAttribute;
                  _this._$signUpTypeId.selectedIndex = _this.signupIdAttribute;
                  _this._$monthId.selectedIndex = _this.monthIdAttribute;
                  event.preventDefault();
                });

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function connectedCallback() {
        return _connectedCallback.apply(this, arguments);
      }

      return connectedCallback;
    }()
  }], [{
    key: "observedAttributes",
    get: function get() {
      return ["target", "targeturl", "programid", "congregationid", "monthid", "ministryid", "eventtypeid", "signuptype", "isfeatured", "keyword", "reduceseriesto"];
    }
  }]);

  return MppEventFinder;
}(ComponentBase);

MppEventFinder.registerComponent("mpp-event-finder", MppEventFinder);